import { Component, Input } from '@angular/core';

@Component({
    selector: 'fdx-form-section',
    styleUrl: './form-section.component.scss',
    templateUrl: 'form-section.component.html',
    standalone: false
})
export class FormSectionComponent {
    @Input() header: string;
}
